<app-dialog-component (okEmitter)="saveDescription()" [formGroup]="descriptionForm" [title]="title$ | async">
  <app-okr-topic-description-form [descriptionForm]="descriptionForm"></app-okr-topic-description-form>
</app-dialog-component>
